import { useGetCustomerUiBehaviorRulesQuery } from '@/common/infrastructure/gql/generated/schema';
import { isRuleEnabled, UI_BEHAVIOR_RULES } from '@/raptorjob/application/utils/erpSettings';

/**
 * Hook to determine if the COD checkbox should be pre-selected for a given customer.
 * Fetches customer-specific UI behavior rules from the backend.
 *
 * @returns Object with isCodPreSelected boolean and loading state
 */
export function useCustomerCodPreSelection() {
  const { data, loading } = useGetCustomerUiBehaviorRulesQuery({
    fetchPolicy: 'network-only'
  });

  const rules = data?.raptorJobSupportingDataQuery?.value?.uiBehaviorRules ?? [];
  const isCodPreSelected = isRuleEnabled(rules, UI_BEHAVIOR_RULES.COD_PRE_SELECTED);

  return { isCodPreSelected, loading };
}
